// src/components/TopBanner.js
import { Box, Typography, Link as MuiLink } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const TopBanner = () => (
  <Box
    sx={{
      background: 'rgba(0, 181, 191, 0.64)',
      backdropFilter: 'blur(6px)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      px: { xs: 2, md: 4 },
      py: { xs: 1, md: 1.5 },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: { xs: 1, md: 3 },
      fontSize: { xs: '13px', md: '14px' },
      fontFamily: 'var(--font-body)',
      color: 'var(--text-main)',
      position: 'relative',
      zIndex: 10,
    }}
  >
    <MuiLink
      href="mailto:info@pilateshoganas.se"
      underline="none"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        transition: 'color 0.3s ease',
        '&:hover': {
          color: 'var(--brand-color)',
        },
      }}
    >
      <EmailIcon sx={{ fontSize: 18, mr: 0.5 }} />
      info@pilateshoganas.se
    </MuiLink>
    <Typography sx={{ color: 'var(--text-muted)' }}>|</Typography>
    <MuiLink
      href="tel:0707945209"
      underline="none"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        transition: 'color 0.3s ease',
        '&:hover': {
          color: 'var(--brand-color)',
        },
      }}
    >
      <PhoneIcon sx={{ fontSize: 18, mr: 0.5 }} />
      0707945209
    </MuiLink>
  </Box>
);

export default TopBanner;
